var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrayHexagon = function SvgGrayHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 340,
    fill: "none",
    viewBox: "0 0 513 539"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    fillRule: "evenodd",
    d: "m304.165 537.004-255.83-93.115L1.057 175.775l208.556-175 255.831 93.116 47.276 268.114-208.556 174.999Z",
    clipRule: "evenodd",
    opacity: 0.102
  })));
};
export default SvgGrayHexagon;